class Filter {

  /** 
   * Подготовка формы к отправке.
   * На основе выбранных пользователем элементов вида:
   *   <input type="checkbox" checked name="price[]" value="1">
   *   <input type="checkbox" name="price[]" value="2">
   *   <input type="checkbox" checked name="price[]" value="3">
   * Формируем значение в элементе, который будет отправляться на сервер:
   *   <input type="hidden" id="price" name="price" value="1_3">
   * 
   * @param {Array<String>} fieldNames Название полей, которые требуют обработки
   */
  prepareForm(fieldNames) {
    // const fieldNames = ['price', 'intensity', 'place', 'dtype']

    fieldNames.forEach((fieldName) => {
      const selector = `input[type="checkbox"][name="${fieldName}\\[\\]"]:checked`,
            checkedItems = document.querySelectorAll(selector),
            targetItem = document.getElementById(fieldName);
      
      if (checkedItems.length > 0) {
        const checkedItemsArray = Array.prototype.slice.call(checkedItems, 0),
              values = checkedItemsArray.map(item => item.value);

        targetItem.value = values.join('_');
      }
      else {
        targetItem.parentNode.removeChild(targetItem);
      }
    })
  }
}

export default Filter;

